<template>
    <div class="table">
        <div class="container">
            <el-form :model="formData" :rules="rules" ref="formData" :label-position="labelPosition" label-width="150px">
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierCode')" prop="supplierCode">
                            <el-input class="de-input" v-model="formData.supplierCode" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierName')" prop="supplierName">
                            <el-input class="de-input" v-model="formData.supplierName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierAddress')" prop="address">
                            <el-input class="de-input" v-model="formData.address" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierCountry')">
                            <el-input class="de-input" v-model="formData.country" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierProvince')">
                            <el-input class="de-input" v-model="formData.province" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierCity')"  prop="city">
                            <el-input class="de-input" v-model="formData.city" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierPostCode')" >
                            <el-input class="de-input" v-model="formData.postCode" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierTelephoneNo')">
                            <el-input class="de-input" v-model="formData.telephoneNo" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item :label="$t('base.supplier.supplierEmailAddress')">
                            <el-input class="de-input" v-model="formData.emailAddress" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row class="btn-row">
                <el-button type="primary" @click="saveCarrier('formData')">{{$t('common.save')}}</el-button>
                <el-button type="primary" @click="cancel">{{$t('common.cancel')}}</el-button>
            </el-row>
        </div>
    </div>
</template>
<script>
    import router from '../../../router';
    import {add}  from "../../../api/base-data/supplier";
    export default {
        name: 'supplier-add',
        data() {
            return {
                formData: {
                    supplierCode: '',
                    supplierName:'',
                    address:'',
                    country:'',
                    province:'',
                    city:'',
                    postCode:'',
                    telephoneNo:'',
                    emailAddress:'',
                    type:'SUPPLIER',
                    status:'1'
                },
                labelPosition: 'right',
                rules: {
                    supplierCode: [{required: true, message: this.$t('base.supplier.supplierCodeInput'), trigger: 'blur' }],
                    supplierName: [{required: true, message: this.$t('base.supplier.supplierNameInput'), trigger: 'blur' }],
                    city: [{required: true, message: this.$t('base.supplier.supplierCityInput'), trigger: 'blur' }],
                }
            }
        },
        methods: {
            //保存承运商主数据
            saveCarrier(formData){

                this.$refs[formData].validate((valid) => {
                    if(valid){
                        add(this.formData).then((res) => {
                            //数据是否插入成功
                            if(res.meta.success){
                                Message({message: this.$t('common.saveSuccess'), type: "success"});
                                this.cancel();
                            }else{
                                Message({message: res.meta.msg, type: "error"});
                            }
                        })

                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            //取消编辑承运商主数据，返回主数据查询
            cancel(){
                router.replace({
                    path: './supplier'
                });
            },
        }
    }
</script>
<style scoped>
    .btn-row{
        margin-bottom: 20px;
        margin-top: 10px;
        text-align: center;
    }
    .de-input{
        width:60%;
    }
    .handle-input{
        width: 60%;
    }
</style>